import docxtemplater from "docxtemplater";
import PizZip from "pizzip";
import JSZipUtils from "jszip-utils";
import moment from 'moment';
import { message } from 'ant-design-vue';
import { docxContent } from "@/utils/util";
const officegen = require("officegen");
const fs = require("fs");
// const { dialog } = require("electron").remote;
import { saveAs } from "file-saver";
export default class Saveprint {
  constructor() {
    this.fileInput = document.createElement('input');
    this.fileInput.type = 'file';
    this.fileInput.id = 'file';
    this.fileInput.hidden = true;
    this.fileInput.webkitdirectory = true;
    this.outputFolderPath = "" //导出位置
    this.dataListSelections = [] //需要导出的数据
    this.exportLoading = false //是否正在导出
    this.exportState = null
    this.dowmloadSelf = null //自定义导出
    this.fileType = [
      {
        id: '1',
        title: '个人档案',
        path: 'static/个人档案.docx'
      },
      {
        id: '2',
        title: '个人承诺书',
        path: 'static/个人承诺书.docx'
      },
      {
        id: '3',
        title: '三级教育卡',
        path: 'static/三级教育卡.docx'
      },
      {
        id: '4',
        title: '劳务合同',
        path: 'static/劳务合同.docx'
      },
      {
        id: '5',
        title: '试卷',
        path: 'static/个人档案.docx'
      },
      {
        id: '6',
        title: '空白模板',
        path: 'static/自定义空白模板.docx',
        blank_title: ''
      }
    ]
    this.fileTypeSelect = []
    // 添加change事件监听器
    this.fileInput.addEventListener('change', this.fileChange);
    console.log(this.fileInput)
  }
  setExportState(callback) {
    this.exportState = callback
  }
  setDowmloadSelf(callback) {
    this.dowmloadSelf = callback
  }
  async fileChange(event) {
    const p = event.target.files[0].path
    // const result = await dialog.showOpenDialog({
    //   properties: ["openDirectory"], // 限制只能选择文件夹
    //   buttonLabel: "选择文件夹", // 自定义对话框按钮的文本
    //   title: "选择文件保存位置", // 对话框标题
    // });
    if (result && result.length > 0) {
      // const that = this
      // 处理文件更改事件的逻辑
      // const p = result[0];
      // const archiver = require("archiver");
      // 创建一个文件夹用于保存文件
      const date = new Date()
      this.outputFolderPath = p + "/人员档案导出" + (date.getMonth() + 1) + '月' + date.getDate() + '日' + date.getHours() + '点' + date.getMinutes() + '分';
      // if (!fs.existsSync(this.outputFolderPath)) {
      //   fs.mkdirSync(this.outputFolderPath);
      // }
      this.startWriteFile()
      event.srcElement.value = ""; //及时清空
    }

  }
  /**
   * 
   * @param {*} dataListSelections 用户数据
   * @param {*} e 需要导出的数据数据格式['1','2']
   */
  fileInit(dataListSelections, e) {
    // console.log(dataListSelections, e)
    if (this.exportLoading) return message.error("正在导出中···")
    this.dataListSelections = dataListSelections //保存需要导出的用户数据
    this.fileTypeSelect = this.fileType.filter(v => e.findIndex(k => v.id === k) > -1)
      .concat(e.filter(v => typeof v === 'object' && v.id.indexOf('6-') > -1).map(v => {
        return {
          ...this.fileType[5],
          blank_title: v.blank_title
        }
      }))
    // console.log(this.fileTypeSelect, '实际导出文件类型集合') //实际导出文件类型集合
    if (this.dowmloadSelf) {
      // console.log(1)
      this.startWriteFile()
    } else {
      // console.log(2)
      // this.fileInput.click()
      this.startWriteFile()
      // this.fileChange()
    }
  }
  getBase64Sync(imgUrl) {
    // console.log('执行getBase64Sync', imgUrl)
    return new Promise((resolve) => {
      var xhr = new XMLHttpRequest();
      xhr.open("get", imgUrl, true);
      // 至关重要
      xhr.responseType = "blob";
      xhr.onload = function () {
        if (this.status == 200) {
          //得到一个blob对象
          var blob = this.response;
          // console.log("blob", blob);
          // 至关重要
          let oFileReader = new FileReader();
          oFileReader.onloadend = function (e) {
            // 此处拿到的已经是 base64的图片了
            let base64 = e.target.result;
            let image = new Image();
            image.src = base64;
            let canvas = document.createElement("canvas");
            canvas.width = image.width;
            canvas.height = image.height;
            let context = canvas.getContext("2d");
            context.drawImage(image, 0, 0, image.width, image.height);
            //返回
            resolve(base64);
          };
          oFileReader.readAsDataURL(blob);
        } else {
          // console.log(imgUrl);
        }
      };
      xhr.send();
    });
  }
  base64DataURLToArrayBuffer(dataURL) {
    const base64Regex = /^data:image\/(png|jpg|jpeg|svg|svg\+xml);base64,/;
    if (!base64Regex.test(dataURL)) {
      return false;
    }
    const stringBase64 = dataURL.replace(base64Regex, "");
    let binaryString;
    if (typeof window !== "undefined") {
      binaryString = window.atob(stringBase64);
    } else {
      binaryString = new Buffer(stringBase64, "base64").toString("binary");
    }
    const len = binaryString.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      const ascii = binaryString.charCodeAt(i);
      bytes[i] = ascii;
    }
    return bytes.buffer;
  }
  startWriteFile = async () => {
    this.exportLoading = true
    //导出状态改变
    if (this.exportState) {
      this.exportState({ exportLoading: this.exportLoading })
    }
    // console.log(this.dataListSelections, 'this.dataListSelections')
    for (let i = 0; i < this.dataListSelections.length; i++) {
      const item = this.dataListSelections[i] //一个人的全部信息
      //预下载图片
      var sign = ""
      var finger = ""
      var jyr1 = ""
      var jyr2 = ""
      var jyr3 = ""
      try {
        if (this.fileTypeSelect.findIndex(v => v.id == 2 || v.id == 3 || v.id == 4 || v.id == 6) > -1) {
          sign = item.sign ? await this.getBase64Sync(item.sign) : '' //wps2.65厘米1.32厘米
          finger = item.finger ? await this.getBase64Sync(item.finger) : '' //wps1.32厘米2.12厘米
          jyr1 = item.jyr1 ? await this.getBase64Sync(item.jyr1) : '' //wps2.65厘米1.32厘米
          jyr2 = item.jyr2 ? await this.getBase64Sync(item.jyr2) : '' //wps2.65厘米1.32厘米
          jyr3 = item.jyr3 ? await this.getBase64Sync(item.jyr3) : '' //wps2.65厘米1.32厘米
        }
      } catch (e) {
        console.log(e)
      }
      for (let index = 0; index < this.fileTypeSelect.length; index++) {
        let _ = this.fileTypeSelect[index] //
        let docxData = {}//文档内容变量
        // imgPath1: await this.getBase64Sync(item.imgPath1),
        if (_.id == 1) {
          //个人档案
          docxData = {
            name: item.name || '',
            gander: item.gender_name || '',
            company_name: item.company_name || '',
            join_time: item.create_time ? moment(item.create_time).format("YYYY年MM月DD日") : '',
            age: item.age || '',
            nation: item.nation || '',
            idno: item.id_no || '',
            native_place: item.native_place || '',
            height: item.height ? item.height + 'cm' : '',
            weight: item.weight ? item.weight + 'kg' : '',
            bp: item.sbp && item.dbp ? `${item.sbp}/${item.dbp}mmhg` : '',
            hr: item.hr ? item.hr + '次/分' : '',
            safety_training: item.safety_training || '',//已进行的安全体验培训
            multimedia_training: item.multimedia_training || '',//已进行的多媒体培训
            score: item.score === null || item.score === undefined ? '' : item.score, //考核得分
            score_list: item.score_list || ''
          };
        } else if (_.id == 2) {
          //个人承诺书
          docxData = {
            project_name: item.project_name || '',
            valueAtitle: item.valueAtitle,
            valueA1: item.valueA1 ? item.valueA1.replace(/↵/g, '\n') : '',
            gzr: item.company_contacts || '',//项目告知人
            sign: sign,
            finger: finger,
            time: moment(item.create_time).format("YYYY年MM月DD日")
          }
        } else if (_.id == 3) {
          // 三级教育卡
          docxData = {
            // jyr: item.company_contacts || '',//教育人
            sign: sign,
            finger: finger,
            valueBtitle: item.valueBtitle || '',
            valueB1: item.valueB1 || '',
            valueB2: item.valueB2 || '',
            valueB3: item.valueB3 || '',
            jyr1: jyr1,
            jyr2: jyr2,
            jyr3: jyr3,
            time1: item.create_time ? moment((new Date(item.create_time).getTime() - 86400000 * 2)).format("YYYY年MM月DD日") : "年  月  日",
            time2: item.create_time ? moment((new Date(item.create_time).getTime() - 86400000)).format("YYYY年MM月DD日") : "年  月  日",
            time3: item.create_time ? moment(item.create_time).format("YYYY年MM月DD日") : "年  月  日",
          }
        } else if (_.id == 4) {
          // 劳务合同
          docxData = {
            valueCtitle: item.valueCtitle || '',
            valueC1: item.valueC1 || '',
            yifang: item.name || '',
            idno: item.id_no || '',
            address: item.address || '',
            phone: item.phone || '',
            sign: sign,
            finger: finger,
          }
        } else if (_.id == 5) {
          const outpath = this.outputFolderPath + `/${item.name ? item.name : ''}`
          if (!fs.existsSync(outpath)) {
            fs.mkdirSync(outpath);
          }
          let docx = officegen("docx");
          if (!item.result) continue
          const result = JSON.parse(item.result)
          if (result.length == 0) return
          docxContent(item, docx, result);
          let out = fs.createWriteStream(
            outpath + `\\${item.person_name}的试卷.docx`
          );
          docx.generate(out);
          continue;
        } else if (_.id == 6) {
          // 空白模板
          docxData = {
            blank_title: _.blank_title || '',
            blank_time: item.blank_time || moment(new Date()).format("YYYY-MM-DD"),
            sign: sign,
            finger: finger,
          }
        }
        // console.log(docxData)
        var ImageModule = require("docxtemplater-image-module-free"); //没有图片可以去掉这一段
        const path = require("path");
        const url =
          process.env.NODE_ENV === "development"
            ? "/" + _.path
            : path.resolve(_.path);
        JSZipUtils.getBinaryContent(url, (error, content) => {
          if (error) {
            console.log(error, 'getBinaryContent error')
            throw error;
          }
          // 图片处理开始
          let opts = {};
          opts = {
            //图像是否居中
            centered: false,
          };
          opts.getImage = (chartId) => {
            return this.base64DataURLToArrayBuffer(chartId);
          };
          opts.getSize = function (img, tagValue, tagName) {
            if (tagName == 'sign' || tagName == 'jyr1' || tagName == 'jyr2' || tagName == 'jyr3') {
              return [100, 50];
            } else if (tagName == 'finger') {
              return [40, 65];
            } else {
              return [200, 150];
            }
          };
          //图片处理结束    没有图片可去掉这一段
          var zip = new PizZip(content);
          var doc = new docxtemplater();
          doc.attachModule(new ImageModule(opts)); //没有图片可以去掉这一段
          doc.loadZip(zip);
          //获取数据
          doc.setData({
            ...docxData,
          });
          doc.setOptions({
            linebreaks: true
          });
          try {
            doc.render();
          } catch (error) {
            debugger
            var e = {
              message: error.message,
              name: error.name,
              stack: error.stack,
              properties: error.properties,
            };
            console.log(
              JSON.stringify({
                error: e,
              })
            );
            // throw error;
          }
          debugger
          let out = doc.getZip().generate({
            type: "blob",
            mimeType:
              "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
          });
          debugger
          if (this.dowmloadSelf) {
            return this.dowmloadSelf({ out: out, title: _.title })
          } else {
            // debugger
            const outpath = this.outputFolderPath + `/${item.name ? item.name : ''}`
            // if (!fs.existsSync(outpath)) {
            //   fs.mkdirSync(outpath);
            // }
            // fs.writeFileSync(outpath + `/${item.name ? item.name + '-' : ''}${_.title}${_.blank_title || ''}.docx`, out);
            saveAs(out, outpath + `/${item.name ? item.name + '-' : ''}${_.title}${_.blank_title || ''}.docx`);

          }
        });
      }
    }
    //导出结束
    let a = setTimeout(() => {
      clearTimeout(a)
      this.exportLoading = false
      //导出状态改变
      if (this.exportState) {
        this.exportState({ exportLoading: this.exportLoading, exportSuccess: true, outputFolderPath: this.outputFolderPath })
      }
    }, 4000);
  }
}